export const front = {
  endpoint: 'api/log',
  batchIntervalInMillis: 5000,
};
